const textFieldModalDocEmployee = {
  label: 'Company'
};

export default textFieldModalDocEmployee;
